module.exports = __webpack_public_path__ + "img/12_klio_14.9cb0b1ad.jpg";